<template>
    <ac-modal title="Report Generator" ref="modalRef" :size-class="'modal-md'">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <form>
                        <div class="row">
                            <div class="col-xs-7">
                                <p>Network Can View Full Payment Reports</p>
                            </div>
                            <div class="col-xs-5">
                                <div class="switch">
                                    <label>
                                        No
                                        <template>
                                            <input type="checkbox" v-model="isChecked"
                                                @change="() => onCheckboxCheck()">
                                        </template>
                                        <span class="lever"></span> Yes
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-xs-12">
                                <select v-model="selectedBatchId" class="form-control">
                                    <option value="0"  disabled>Select a Report Date</option>
                                    <option v-for="r in reports" :value="r.batchId">
                                        {{r.batchDate}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                            <ac-button class="btn btn-sm btn-green" :action="exportReport">Export</ac-button>
                        </div>
                    </div>
                </div>
            </div>  
            <br/>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import {reportFileNameUtilities} from "../../../../components/shared/scripts/reportFileNameUtilities.js";
    
    export default {
        name: "ReportGeneratorModal",
        
        data() {
            return {
                reports: [],
                selectedBatchId: 0,
                providerEntityId: 0,
                isChecked: false
            };
        },
        computed: {
            batchSelected() {
                return this.selectedBatchId!=0;
            } 
        },
        methods: {
            async showModal(data) {
                this.providerEntityId = data.providerEntityId;
                this.reports = await api.getData('PaymentReport', data.providerEntityId, 'GetProviderBatches');
                this.isChecked = this.reports.some(p => p.hasPaymentReport === true);
                this.$refs.modalRef.open();        
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            exportReport() {
                const selectedBatch = this.reports.find(r => Number(r.batchId) === Number(this.selectedBatchId));
                const fileName = reportFileNameUtilities.buildFileName('NetworkFullPaymentReport', selectedBatch);
                common.downloadFile(
                    "ProviderEntity/" + this.providerEntityId + "/ExportNetworkFullPaymentReport/" + this.selectedBatchId,
                    fileName
                );
            },       
            async onCheckboxCheck() {
                await api.post('ProviderEntity', `${this.providerEntityId}/SetNetworkHasPaymentReport/${this.isChecked}`);
                setTimeout(() => { this.$refs.modalRef.close(); }, 1000);
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>